import { ProductToUpdate } from '@/server/api/schemas/configuration.types';
import { ConfigurationProducts } from '@/server/api/schemas/configuration.types';

export const updateConfigurationProductsLocally = (
  products: ConfigurationProducts,
  productsToUpdate: ProductToUpdate[],
): ConfigurationProducts =>
  Object.entries(products)
    .map(([key, value]) => {
      // is product list
      if (Array.isArray(value)) {
        const products = value.map((product) => {
          const updatedProduct = productsToUpdate.find(
            (productToUpdate) => productToUpdate.id === product.id,
          );

          if (updatedProduct?.count === 0) {
            return null;
          }

          return updatedProduct
            ? {
                ...product,
                ...updatedProduct,
              }
            : product;
        });
        return [key, products.filter((n) => n)] as const;
      }

      // is singular product
      const updatedProduct = productsToUpdate.find(
        (productToUpdate) => productToUpdate.id === value?.id,
      );
      if (updatedProduct?.count === 0) {
        return [key, null] as const;
      }
      const product = updatedProduct ? { ...value, ...updatedProduct } : value;
      return [key, product] as const;
    })
    .reduce<Record<string, unknown>>((products, [key, value]) => {
      products[key] = value;
      return products;
    }, {});
